<template lang="pug">
	.menu-button(@click.prevent.stop="onClick" v-bind:class="activeClass")
		.bars
</template>

<script>
export default {
	name : 'MenuButton',
	props: {
		active: Boolean
	},
	computed: {
		activeClass () {
			return { 'is-active': this.active }
		}
	},
	methods: {
		onClick (ev) {
			if (this.active) {
				this.$emit('close')
			} else {
				this.$emit('open')
			}
		}
	}
}
</script>

<style lang="stylus" scoped>
	$bar-length = 30px
	$bar-thickness = 5px
	$bar-color = #aeb2b4

	.menu-button
		display block
		position absolute
		top 2rem
		right 1rem
		padding $bar-thickness*2 0
		transition 0.2s ease-in-out
		cursor pointer
		z-index 99

		@media (min-width: 340px)
			right 1.5rem

		@media (min-width: 650px)
			right auto
			top 2rem
			left 2rem
			left 6vmin

		@media (max-width: 900px) and (min-height: 1200px), (max-width: 800px) and (min-height: 1000px)
			top 2.8rem
			right 1rem
			left unset

		.bars
			position relative

			&, &:before, &:after
				width $bar-length
				height $bar-thickness
				background-color $bar-color
				transition 0.2s ease-in-out
				border-radius 2px
				box-shadow none

			&:before, &:after
				content ''
				display block
				position absolute
				top 0
				left 0
				will-change transform

			&:before
				transform translateY(-($bar-thickness*2))

			&:after
				transform translateY(($bar-thickness*2))

		&.is-active
			transform rotate(-45deg)
			.bars
				&:before, &:after
					transform translateX(0) rotate(-90deg)

	@media (hover: hover)
		.menu-button:hover
			.bars
				&, &:before, &:after
					box-shadow 0 0 2px #FFF
</style>
